import { Box } from '@chakra-ui/react'
import isEmpty from 'lodash/isEmpty'
import type { FC } from 'react'

import MarkdownDisplay from '@app/shared/markdownDisplay'
import type { DomainBusinessContext } from '@app/types'

interface Props {
  businessContext?: DomainBusinessContext
  lineClamp?: number
}

const BusinessContextContentPreview: FC<Props> = ({ businessContext, lineClamp = 6 }) => {
  if (!businessContext || isEmpty(businessContext?.content)) {
    return null
  }

  return (
    <Box fontSize="sm" color="fg.muted" lineClamp={lineClamp}>
      <MarkdownDisplay text={businessContext.content} />
    </Box>
  )
}

export default BusinessContextContentPreview
